import {SecurityIssue} from "./security-issue";
import {SecurityVulnerability} from "./security-vulnerability";

export class SecurityScan {

  public id: string;
  public issues: SecurityIssue[];
  public vulnerabilities: SecurityVulnerability[];

}
